import { sdk } from 'utils/query';
import { MfaType } from 'models/general';
import { Presence, TotpMethod } from '@extrahorizon/javascript-sdk';
import { useCustomMutation } from '../../useCustomMutation';

interface ConfirmPresenceProps {
  password: string;
  userIdToAddTotp?: string;
  callback: (result: ConfirmPresenceResult) => void;
}

export interface ConfirmPresenceResult {
  confirmPresenceToken: Presence;
  mfaMethod?: TotpMethod;
}

const confirmPresence = async ({ password, userIdToAddTotp }: ConfirmPresenceProps) => {
  const confirmPresenceToken = await sdk.auth.confirmPresence({ password });

  if (userIdToAddTotp) {
    const mfaMethod = await sdk.auth.users.addMfaMethod(userIdToAddTotp, {
      presenceToken: confirmPresenceToken.token,
      type: MfaType.Totp,
      name: MfaType.Totp,
      tags: [],
    });
    return { confirmPresenceToken, mfaMethod };
  }

  return { confirmPresenceToken };
};

export const useConfirmPresence = () => {
  return useCustomMutation({
    fn: confirmPresence,
    onSuccess: {
      callback: async (data, variables) => {
        variables.callback?.(data);
      },
    },
  });
};
